// extracted by mini-css-extract-plugin
export var container = "index-module--container--nJ3+Y";
export var copy = "index-module--copy--ODkOS";
export var fadein = "index-module--fadein--p+ykg";
export var field = "index-module--field--4+s7+";
export var fields = "index-module--fields--GmRxT";
export var title = "index-module--title--CVb55";
export var wrapper = "index-module--wrapper--WoTvI";